import React from "react";
import { useNavigate } from "react-router-dom";
import Lottie from "lottie-react";
import kittyCatError404Animation from "../assets/KittyCatError404.json";
import Icon from "./Icon";

const NotFound = () => {
  const navigate = useNavigate();

  return (
    <div
      style={{
        minHeight: "100vh",
        backgroundColor: "var(--color-background)",
        display: "flex",
        flexDirection: "column",
        alignItems: "center",
        justifyContent: "center",
        padding: "2rem",
        textAlign: "center",
      }}
    >
      <div style={{ maxWidth: "500px", width: "100%", margin: "0 auto" }}>
        <Lottie
          animationData={kittyCatError404Animation}
          loop={true}
          autoplay={true}
        />
      </div>

      <h1
        className="mt-4 mb-3"
        style={{
          color: "var(--color-primary)",
          fontSize: "2.5rem",
          fontWeight: "700",
        }}
      >
        404 - Página Não Encontrada
      </h1>

      <p
        className="text-muted mb-4"
        style={{
          fontSize: "1.1rem",
          maxWidth: "500px",
        }}
      >
        Ops! A página que você está procurando não existe ou foi removida.
      </p>

      <div className="d-flex flex-wrap gap-3 justify-content-center">
        <button
          className="btn btn-primary d-inline-flex align-items-center gap-2"
          onClick={() => navigate("/dashboard")}
          style={{
            padding: "0.75rem 1.5rem",
            fontSize: "1rem",
            fontWeight: "600",
          }}
        >
          <Icon name="home" size={18} />
          Ir para Dashboard
        </button>

        <button
          className="btn btn-outline-primary d-inline-flex align-items-center gap-2"
          onClick={() => navigate(-1)}
          style={{
            padding: "0.75rem 1.5rem",
            fontSize: "1rem",
            fontWeight: "600",
          }}
        >
          <Icon name="arrow-left" size={18} />
          Voltar
        </button>
      </div>

      <div
        className="mt-5 p-4"
        style={{
          backgroundColor: "var(--color-surface)",
          borderRadius: "var(--radius-lg)",
          border: "1px solid var(--color-border-light)",
          maxWidth: "600px",
        }}
      >
        <h6 className="mb-3" style={{ color: "var(--color-text)" }}>
          <Icon name="info" size={18} className="me-2" />
          Precisa de ajuda?
        </h6>
        <p className="text-muted mb-3" style={{ fontSize: "0.95rem" }}>
          Se você acredita que esta página deveria existir, entre em contato com
          o administrador do sistema.
        </p>
        <a
          href="https://wa.me/qr/AUDCWZRJVOY3N1"
          target="_blank"
          rel="noopener noreferrer"
          className="btn btn-success btn-sm d-inline-flex align-items-center gap-2"
          style={{
            textDecoration: "none",
          }}
        >
          <Icon name="phone" size={16} />
          Falar com Administrador
        </a>
      </div>
    </div>
  );
};

export default NotFound;
